import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Stage from "@frog/source/models/Stage.js"
import Zone from "@frog/source/models/Zone.js"

let UnitSprite = function() {}
import("@frog/source/views/components/UnitSprite.jsx").then((module) => UnitSprite = module.default)
import UnitHealthBar from "@frog/source/views/components/UnitHealthBar.jsx"
import Dice from "@frog/source/data/games/dice/views/Dice.jsx"
import DiceCube from "@frog/source/data/games/dice/views/DiceCube.jsx"
import DiceLayout from "@frog/source/data/games/dice/views/DiceLayout.jsx"

import {Roll} from "@frog/source/data/games/dice/scripts/Rolling.js"
import CarryOn from "@frog/source/data/games/dice/scripts/CarryOn.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"

import "./Modals.less"

function onClickDone(stage) {
    return function(event) {
        CarryOn(stage)
    }
}

export default function FrogModal() {
    return PlotSteps.CustomViewModal({
        "view": (stage) => {
            if(App?.game == undefined) return
            const unit = stage.units["frog"]
            return (
                <div class="FrogModal">
                    <div class="Header">
                        <div class="BigText">Strike up a tune!!</div>
                        <div class="SmallText">The Banjtoad has joined your party</div>
                    </div>
                    <section class="UnitsSection">
                        <div class="Unit">
                            <div class="Thumbnail">
                                <UnitSprite unit={unit}/>
                                <UnitHealthBar unit={unit} maxsegments={20}/>
                            </div>
                            <div class="EquippableDice">
                                <div class="Description">{unit.subtitle} Dice:</div>
                                <DiceLayout items={unit.diceFaces} unit={unit} stage={stage}
                                    equippedItem={unit.equippedItem} key={unit.rollcount}/>
                            </div>
                        </div>
                    </section>
                    <section class="DoneSection">
                        <button onClick={onClickDone(stage)} isEnabled={true}>Continue</button>
                    </section>
                </div>
            )
        }
    })
}
